const defaultLocation = {
  lat: 37.9838,
  lng: 23.7275,
};

export const getBrowserLocation = () => {
  return new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude: lat, longitude: lng } = pos.coords;
          resolve({ lat, lng });
        },
        () => {
          reject(defaultLocation);
        }
      );
    } else {
      reject(defaultLocation);
    }
  });
};
